import { Spin } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useQuantity } from "../../hooks/useQuantity";
import { addProductToCart } from "../../redux/reducers/slice/cart";
import { selectIsCheckGrandOpeningPromotion } from "../../redux/reducers/slice/common";
import products from "../../services/products";
import {
  checkGrandOpeningPromotion,
  getKindOfBed,
  getProductPropertyForProductWish,
  getSlugByLanguage,
} from "../../shared/helpers";
import NotificationAddToCartSuccess from "../notification";
import ProductItemComponent from "../productItem";

const ProductWishItem = (props: any) => {
  const { i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { product, removeProduct, index } = props;
  const [quantity, decreaseQuantity, increaseQuantity, resetQuantity] =
    useQuantity(1);
  const isCheckGrandOpeningPromotion = useSelector(
    selectIsCheckGrandOpeningPromotion
  );
  const dispatch = useDispatch();

  const handleHeart = (
    product_feature_code: string,
    kde_pro_id: string,
    kde_pro_spec_id: number
  ) => {
    setLoading(true);
    products.editProductWishV2(
      { product_feature_code, kde_pro_id, kde_pro_spec_id, wish: false },
      (data, err) => {
        if (data) {
          setLoading(false);
          removeProduct(product_feature_code);
        }
      }
    );
  };

  const handleAddToCart = async () => {
    const _data = {
      _id: product._id,
      slug: product.slug || "",
      slug_en: product.slug_en || "",
      cat_id_v2: product._id,
      code: product.feature_code,
      parent_pro_id: product.parent_pro_id,
      disable_buy_button: product.disable_buy_button,
      disable_buy_button_message: product.disable_buy_button_message,
      feature: {
        currency: "VNĐ",
        discount_percent: product.discount_percent,
        feature_id: product.feature_id,
        price: product.price,
        price_promotion: product.price_promotion,
        price_save: product.price_save,
        product_cat_id: product._id,
        spec: product.feature_name,
      },
      product_property: getProductPropertyForProductWish(product),
      // gift_quantity: 1,
      img: product.spec_img || product.img,
      name: product.name,
      // services: prod.services,
      wish: false,
      category_name: product.category_name,
    };
    const addToCartResponse = await dispatch(
      addProductToCart(_data, true, quantity)
    );

    if (!addToCartResponse) {
      NotificationAddToCartSuccess({
        productName: product.name,
        productFeature: product.feature_name,
      });

      let parentNode = document.getElementsByClassName(
        "product-wishes-list"
      )[0];

      if (!parentNode) {
        return false;
      }

      return { parentNode, index };
    }

    return false;
  };

  const getProductItemProps = () => ({
    img: product.spec_img_id || product.img_id,
    productPath: getSlugByLanguage(product, i18n.language),
    productId: product._id,
    name: product.name,
    featureCode: product.feature_code,
    pattern_name: product.spec_name || null,
    price: product.price,
    price_promotion: product.price_promotion,
    discount_percent: product.discount_percent,
    price_installment: product.price_installment,
    info_promotion: product.info_promotion,
    category_name: product.category_name,
    quantity: quantity,
    features: {
      options: null,
      currentValue: { label: product.feature_name },
      handleOnChange: null,
      is_need_dropdown_features: product.is_need_dropdown_features,
      is_label_dropdown: product.is_label_dropdown,
      is_special_category: product.is_special_category,
      is_hide_thick_dropdown: product.is_hide_thick_dropdown,
      is_normal_dropdown: product.is_normal_dropdown,
    },
    covers: {
      isNeedDropdown: false,
      labelDefault: getKindOfBed(product.feature_code, product.product_props),
    },
    foams: null,
    desk: null,
    isHaveMoreGift: checkGrandOpeningPromotion(
      isCheckGrandOpeningPromotion,
      product.price,
      product._id
    ),
    isNeedCompare: false,
    isInCompareList: null,
    isNeedContact: product.is_need_contact,
    addToCart: handleAddToCart,
    decreaseQuantity: decreaseQuantity,
    increaseQuantity: increaseQuantity,
    resetQuantity: resetQuantity,
    addToCompare: null,
    removeFromCompare: null,
    renderWishButton: () => (
      <a
        className="button-heart"
        onClick={() =>
          handleHeart(
            product.feature_code,
            product.kde_pro_id,
            product.kde_pro_spec_id
          )
        }>
        <img
          src="https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1627042897-icon_heart-51.svg"
          alt=""
        />
      </a>
    ),
  });

  return (
    <div className="product-wish-item-container">
      {loading ? <Spin /> : <ProductItemComponent {...getProductItemProps()} />}
    </div>
  );
};

export default ProductWishItem;
